import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

export const Page = styled(Flex)(({ theme }) => ({
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "100%",
  backgroundColor: theme.colors.sysBackgroundDefault,
}));

export const Content = styled(Flex)({
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  padding: "48px 80px",
  width: "100%",
  maxWidth: 1200,
});
